// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1N01f","title":"styles_title__3_lCQ"};